'use strict';
import { isMoment } from 'moment';
import moment from 'moment-timezone';
angular.module('docketbook').
  service('docketService', function (orderService, userService, jobService, accessControl, $http, $stateParams, $cookies, $q, Restangular, geolocation, $timeout, $rootScope, Upload) {

    /**** Save a my docket signature ****/
    this.saveMyDocketSignature = function (docket, successCb, failureCb) {
      var currentUser = accessControl.currentUser();
      var docket = angular.copy(docket);
      var url = DOCKETBOOK_API_URL + '/' + $rootScope.urlVersion + "/dockets/" + docket.id + "/attachment";

      // check if the user is in the context of an org -> i.e. they are signing as the customer
      if (accessControl.currentOrg() && accessControl.currentOrgGroup()) {
        url = DOCKETBOOK_API_URL + '/' + $rootScope.urlVersion + "/organisations/" + accessControl.currentOrg().id + "/groups/" + accessControl.currentOrgGroup().id + "/dockets/" + docket.id + "/attachment";
      }

      var signatureImage = docket.customerSignatureData;
      var filename = 'customer-signature';
      var body = '--__TEST123__\r\ncontent-disposition: form-data; name="file"; filename="' + filename + '"\r\ncontent-type: image/png\r\nContent-Transfer-Encoding: base64\r\n\r\n' + signatureImage + '\r\n';
      body += "--__TEST123__";
      if (docket.customerSignatureName) {
        body += "\r\n";
        body += 'content-disposition: form-data; name="jsondata";filename="customername.json"\r\ncontent-type: application/json\r\n\r\n{"customerSignatureName":"' + docket.customerSignatureName + '"}\r\n--__TEST123__--\r\n';
      } else {
        body += "--";
      }
      var header = 'multipart/form-data; boundary="__TEST123__"';
      $http.put(url, body, {
        headers: { 'Content-Type': header },
        withCredentials: true,
      }).success(function (result) {
        successCb();
        return;
      }).error(function (err) {
        failureCb();
        return;
      });
    }

    /**** Save a docket ****/
    var saveDocket = function (docket, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var currentUser = accessControl.currentUser();
      var docket = angular.copy(docket);
      var baseDockets = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('dockets');
      if (docket.docketNumber == "New Docket") {
        delete docket.docketNumber;
      }
      if (docket.date) {
        docket.date = moment(docket.date).format('YYYY-MM-DD');
      }
      if (docket.startTime) {
        docket.startTime = docket.startTime.toISOString();
      }
      if (docket.endTime) {
        docket.endTime = docket.endTime.toISOString();
      }
      if (docket.breakTime) {
        docket.breakTime = parseInt(docket.breakTime);
      }
      if (docket.travelTime) {
        docket.travelTime = parseInt(docket.travelTime);
      }


      // update line items to have id's for ref'd items - not objects
      if (docket.lineItems != null) {
        for (var i = 0; i < docket.lineItems.length; i++) {
          docket.lineItems[i].resource = docket.lineItems[i].resource.id;
        }
      }

      if (docket.orderRef != null && docket.orderRef.id != null) {
        docket.orderRef = docket.orderRef.id;
      } else if (docket.orderRef == null) {
        delete docket.orderRef;
      }

      if (docket.jobRef != null && docket.jobRef.id != null) {
        docket.jobRef = docket.jobRef.id;
      }

      // update templateValueStore date/datetime and time values to be iso strings
      var signatureFieldsToSave = [];
      if (docket.template != null && docket.templateValueStore != null) {
        for (var i = 0; i < docket.template.blocks.length; i++) {
          var thisBlock = docket.template.blocks[i];
          for (var j = 0; j < thisBlock.fields.length; j++) {
            var thisField = thisBlock.fields[j];

            if (thisField.type == 'date') {
              var beforeValue = docket.templateValueStore[thisBlock.id + '-' + thisField.id];
              var afterValue = moment(beforeValue).format('YYYY-MM-DD');
              afterValue += "T00:00:00.000Z";
              if (beforeValue != "" && beforeValue != null) {
                docket.templateValueStore[thisBlock.id + '-' + thisField.id] = afterValue;
              }
            } else if (thisField.type == 'datetime' || thisField.type == 'time') {
              // convert date to ISO STRING
              var beforeValue = docket.templateValueStore[thisBlock.id + '-' + thisField.id];
              if (beforeValue != "" && beforeValue != null) {
                docket.templateValueStore[thisBlock.id + '-' + thisField.id] = moment(beforeValue).toISOString();
              }
            } else if (thisField.type == 'number') {
              // convert string to integer
              var beforeValue = docket.templateValueStore[thisBlock.id + '-' + thisField.id];
              docket.templateValueStore[thisBlock.id + '-' + thisField.id] = parseFloat(beforeValue);
            }
          }
        }
      }

      // update resource/interaction custom field value store date value to be iso strings
      if (docket.resources != null) {
        for (var i = 0; i < docket.resources.length; i++) {
          if (docket.resources[i].interactions != null) {
            for (var j = 0; j < docket.resources[i].interactions.length; j++) {
              if (docket.resources[i].interactions[j].customFields) {
                docket.resources[i].interactions[j].customFields =
                  Object.fromEntries(
                    Object.entries(docket.resources[i].interactions[j].customFields)
                    .filter(([ _, v ]) => v != null)
                  )
              }

              for (var k = 0; k < docket.resources[i].interactions[j].interactionTemplate.fields.length; k++) {
                var field = docket.resources[i].interactions[j].interactionTemplate.fields[k];
                if (field.type == 'date' && docket.resources[i].interactions[j].customFields[field.id]) {
                  var dateTransformed = moment(docket.resources[i].interactions[j].customFields[field.id]).format('YYYY-MM-DD');
                  dateTransformed += "T00:00:00.000Z";
                  docket.resources[i].interactions[j].customFields[field.id] = dateTransformed;
                }
              }
            }
          }
        }
      }

      if (docket.status) {
        docket.status = docket.status.toLowerCase();
      }

      // convert accessControlEdit back to accessControl
      if (docket.accessControlEdit) {
        var accessControlEdited = {};
        for (var i = 0; i < docket.accessControlEdit.length; i++) {
          if (docket.accessControlEdit[i].new && docket.accessControlEdit[i].email != "") {
            var accessLevelsEdit = { 'add': docket.accessControlEdit[i].accessLevels };
            accessControlEdited[docket.accessControlEdit[i].email] = accessLevelsEdit;
          }
        }
        docket.accessControl = accessControlEdited;
      }

      docket.signatureFieldsToSave = [];
      if (docket.signatureFields) {
        var keys = Object.keys(docket.signatureFields);
        for (var i = 0; i < keys.length; i++) {
          docket.signatureFieldsToSave.push(docket.signatureFields[keys[i]]);
        }
      }

      delete docket.customerSignature;
      delete docket.supplierSignature;

      // TODO: maybe remove this after fixing in order setup?
      /*if ( docket.customerContact != null ) {
        var addressKeys = Object.keys(docket.customerContact.contactAddresses);
        for ( var i = 0; i < addressKeys.length; i++ ) {
          if ( docket.customerContact.contactAddresses[addressKeys[i]] == null || docket.customerContact.contactAddresses[addressKeys[i]].length == 0 ) {
            docket.customerContact.contactAddresses[addressKeys[i]] = ['approver'];
          }
        }
      }*/

      if (docket.id == null) {
        // new docket - post new
        docket.status = "draft";
        if (!docket.author) {
          docket.author = currentUser.id;
        }
        docket.organisation = organisation.id;
        if (organisationGroup != null) {
          docket.organisationGroup = organisationGroup.id;
        }
        baseDockets.post(docket).then(successCb, failureCb);
      } else {
        // existing docket - put updated version - upload newly added signatures first
        uploadSignaturesBeforeSave(docket, function () {
          baseDockets.one(docket.id).customPUT(docket).then(successCb, failureCb);
        }, function (err) {
          failureCb({ status: 551 });
          return;
        });
      }
    }

    var uploadSignaturesBeforeSave = function (docket, successCb, failureCb) {
      if (docket.supplierSignatureData == null && docket.customerSignatureData == null && docket.signatureFieldsToSave.length <= 0) {
        successCb();
        return;
      }

      uploadSignature('supplier', docket, function () {
        uploadSignature('customer', docket, function () {
          uploadFieldSignatures(docket, 0, function () {
            successCb();
            return;
          });
        }, function (err) {
          failureCb();
          return;
        });
      }, function (err) {
        failureCb();
        return;
      });
    }

    var uploadSignature = function (type, docket, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      if ((type == 'supplier' && !docket.supplierSignatureData) || (type == 'customer' && !docket.customerSignatureData)) {
        successCb();
        return;
      }
      var signatureImage = docket.supplierSignatureData;
      var filename = 'supplier-signature';
      if (type == 'customer') {
        signatureImage = docket.customerSignatureData;
        filename = 'customer-signature';
      }
      var url = DOCKETBOOK_API_URL + '/' + $rootScope.urlVersion + '/organisations/' + organisation.id + "/groups/" + organisationGroup.id + "/dockets/" + docket.id + "/attachment";
      var body = '--__TEST123__\r\ncontent-disposition: form-data; name="file"; filename="' + filename + '"\r\ncontent-type: image/png\r\nContent-Transfer-Encoding: base64\r\n\r\n' + signatureImage + '\r\n';
      body += "--__TEST123__--\r\n";
      var header = 'multipart/form-data; boundary="__TEST123__"';
      $http.put(url, body, {
        headers: { 'Content-Type': header },
        withCredentials: true,
      }).success(function (result) {
        successCb();
        return;
      }).error(function (err) {
        failureCb();
        return;
      });
    }

    var uploadFieldSignatures = function (docket, index, successCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();

      if (index > docket.signatureFieldsToSave.length - 1) {
        successCb();
        return;
      }

      var fieldToSave = docket.signatureFieldsToSave[index];
      var signatureImage = fieldToSave.signatureImage;
      var filename = fieldToSave.displayName;
      var url = DOCKETBOOK_API_URL + '/' + $rootScope.urlVersion + '/organisations/' + organisation.id + "/groups/" + organisationGroup.id + "/dockets/" + docket.id + "/attachment";
      var body = '--__TEST123__\r\ncontent-disposition: form-data; name="description"\r\n\r\nthis is a customer signature field\r\n';
      body += '--__TEST123__\r\ncontent-disposition: form-data; name="uploadType"\r\n\r\nfieldSignature\r\n';
      body += '--__TEST123__\r\ncontent-disposition: form-data; name="blockId"\r\n\r\n' + fieldToSave.blockId + '\r\n';
      body += '--__TEST123__\r\ncontent-disposition: form-data; name="fieldId"\r\n\r\n' + fieldToSave.fieldId + '\r\n';
      body += '--__TEST123__\r\ncontent-disposition: form-data; name="file"; filename="' + filename + '"\r\ncontent-type: image/png\r\nContent-Transfer-Encoding: base64\r\n\r\n' + signatureImage + '\r\n';
      body += "--__TEST123__--\r\n";
      var header = 'multipart/form-data; boundary="__TEST123__"';
      $http.put(url, body, {
        headers: { 'Content-Type': header },
        withCredentials: true,
      }).success(function (result) {
        docket.signatureFields[fieldToSave.blockId + '-' + fieldToSave.fieldId] = null;
        uploadFieldSignatures(docket, index + 1, successCb);
        return;
      }).error(function (err) {
        uploadFieldSignatures(docket, index + 1, successCb);
        return;
      });
    }

    /**** External ref to saveDocket ****/
    this.saveDocket = saveDocket;

    /**** Save Docket Signatures *****/
    this.saveDocketCustomerSignature = function (docketId, customerSignatureName, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseDockets = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('dockets');

      var docketId = docketId;
      if (docketId.id != null) {
        docketId = docketId.id;
      }
      var docketObj = {};
      if (customerSignatureName) {
        docketObj = { customerSignatureName: customerSignatureName };
      }
      baseDockets.one(docketId).customPUT(docketObj).then(successCb, failureCb);
    }

    /**** Get a single docket *****/
    var getDocket = function (docketId, populateOrderJob, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var currentUser = accessControl.currentUser();
      var baseDockets = null;
      if (organisation != null) {
        baseDockets = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('dockets');
      } else {
        baseDockets = Restangular.all('dockets');
      }

      if (docketId.id != null) {
        docketId = docketId.id;
      }

      baseDockets.one(docketId).customGET("", { populate: true }).then(function (docket) {
        var timezone = docket.timezone;
        if (timezone == null && organisationGroup != null && organisationGroup.timezone != null) {
          timezone = organisationGroup.timezone;
        } else if (timezone == null) {
          timezone = moment.tz.guess();
        }
        docket.status = docket.status.charAt(0).toUpperCase() + docket.status.slice(1);
        setupDocketValueStore(docket);
        if (organisation != null) {
          setupDocketChecklists(docket);
        }
        setupDocketResourceInteractionStore(docket);

        // prepare dates correctly
        if (docket.date) {
          docket.date = moment(docket.date).toDate();
        }
        if (docket.startTime) {
          docket.startTime = moment(docket.startTime).tz(timezone);
        }
        if (docket.endTime) {
          docket.endTime = moment(docket.endTime).tz(timezone);
        }

        // lock down customer if orderRef
        if (docket.orderRef != null) {
          docket.customerLocked = true;
        }

        // If in myDocketbook - check if docket is assigned to an org
        docket.assigned = false;
        if (organisation == null || organisationGroup == null) {
          var orgEmails = userService.getOrgEmailAddresses();
          for (var key in docket.accessControl) {
            if (orgEmails.indexOf(key) != -1) {
              docket.assigned = true;
              break;
            }
          }
        }

        // if not assigned - get users accessLevel
        if (!docket.assigned && docket.accessControl[currentUser.emailAddress] != null) {
          docket.userAccessLevels = docket.accessControl[currentUser.emailAddress];
        }

        // get signature attachment id's
        if (docket.attachments) {
          for (var i = 0; i < docket.attachments.length; i++) {
            if (docket.attachments[i].fileName == 'customer-signature') {
              docket.customerSignatureAttachment = docket.attachments[i].id;
            } else if (docket.attachments[i].fileName == 'supplier-signature') {
              docket.supplierSignatureAttachment = docket.attachments[i].id;
            }
          }
        }

        if (!populateOrderJob) {
          successCb(docket);
          return;
        }

        // populate job / order for getting full line item detail
        if (docket.jobRef != null && (accessControl.userHasPermission('io.docketbook.ojdapi.getJob') || accessControl.userHasPermission('io.docketbook.ojdapi.getMyJob'))) {
          var jobId = docket.jobRef;
          if (jobId.id != null) {
            jobId = jobId.id;
          }
          jobService.getJob(jobId, function (fullJob) {
            docket.jobRef = fullJob;
            successCb(docket);
          }, function (err) {
            successCb(docket);
          });
        } else if (docket.orderRef != null && accessControl.userHasPermission('io.docketbook.ojdapi.getOrder')) {
          var orderId = docket.orderRef;
          if (orderId.id != null) {
            orderId = orderId.id;
          }
          orderService.getOrder(orderId, function (fullOrder) {
            docket.orderRef = fullOrder;
            successCb(docket);
          }, function (err) {
            successCb(docket);
          });
        } else {
          successCb(docket);
        }
      }, failureCb);
    }

    this.getDocket = getDocket;

    /**** Delete a docket ****/
    var deleteDocket = function (docket, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseDockets = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('dockets');

      var docketId = docket;
      if (docketId.id != null) {
        docketId = docketId.id;
      }
      baseDockets.one(docketId).remove().then(successCb, failureCb);
    }

    this.deleteDocket = deleteDocket;

    /***** Delete Bulk Dockets *****/
    this.deleteBulkDockets = function (dockets, successCb) {
      var failures = [];
      deleteDockets(dockets, 0, failures, function (failuresFilled) {
        successCb(failuresFilled);
      });
    }

    var deleteDockets = function (list, index, failures, successCb) {
      if (index >= list.length) {
        successCb(failures);
        return;
      }

      deleteDocket(list[index].id, function (success) {
        deleteDockets(list, index + 1, failures, successCb);
      }, function (err) {
        failures.push(list[index]);
        deleteDockets(list, index + 1, failures, successCb);
      });
    }

    /**** Update Docket Access Control *****/
    this.updateAccessControl = function (docket, accessControlPayload, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseDockets = Restangular.all('dockets');
      if (organisation != null && organisationGroup != null) {
        baseDockets = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('dockets');
      }

      var docketId = docket;
      if (docketId.id != null) {
        docketId = docketId.id;
      }

      var accessControlFull = { 'accessControl': accessControlPayload };
      baseDockets.one(docketId).customPUT(accessControlFull).then(successCb, failureCb);
    }

    /***** Re-assign Docket *****/
    this.reassignDocket = function (docket, losingPrincipal, gainingPrincipal, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseDockets = Restangular.all('dockets');
      if (organisation != null && organisationGroup != null) {
        baseDockets = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('dockets');
      }

      var docketId = docket;
      if (docketId.id != null) {
        docketId = docketId.id;
      }

      var payload = { 'losingPrincipal': losingPrincipal, 'gainingPrincipal': gainingPrincipal };
      baseDockets.one(docketId).all('reassign').customPOST(payload).then(successCb, failureCb);
    }

    /**** Send a docket ****/
    var sendDocket = function (original, docket, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseDockets = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('dockets');

      if (docket.id == null) {
        // new docket - save first
        saveDocket(docket, function (docketUpdated) {
          var docketObject = {};
          docketObject.status = 'sent';

          if (navigator && navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function (data) {
              var coords = data.coords;
              docketObject.lat = coords.latitude;
              docketObject.long = coords.longitude;
              baseDockets.one(docketUpdated.id).customPUT(docketObject).then(successCb, failureCb);
            }, function (err) {
              baseDockets.one(docketUpdated.id).customPUT(docketObject).then(successCb, failureCb);
            }, { enableHighAccuracy: true, timeout: 5000 });
          } else {
            baseDockets.one(docketUpdated.id).customPUT(docketObject).then(successCb, failureCb);
          }

          /*geolocation.getLocation().then(function(data) {
            var coords = data.coords;
            docketObject.lat = coords.latitude;
            docketObject.long = coords.longitude;
            baseDockets.one(docketUpdated.id).customPUT(docketObject).then(successCb, failureCb);
          }, function(err) {
            baseDockets.one(docketUpdated.id).customPUT(docketObject).then(successCb, failureCb);
          });*/
        }, function (err) {
          failureCb('Error saving docket');
        });
      } else {
        // not a new docket - get diff of changes and save if required
        getDiffedDocket(original, docket, 'resources', function (diff, diffCount) {
          if (diffCount > 0) {
            diff.status = 'sent';

            if (navigator && navigator.geolocation) {
              navigator.geolocation.getCurrentPosition(function (data) {
                var coords = data.coords;
                diff.lat = coords.latitude;
                diff.long = coords.longitude;
                saveDocket(diff, successCb, failureCb);
              }, function (err) {
                saveDocket(diff, successCb, failureCb);
                baseDockets.one(docket.id).customPUT(diff).then(successCb, failureCb);
              }, { enableHighAccuracy: true, timeout: 5000 });
            } else {
              saveDocket(diff, successCb, failureCb);
              baseDockets.one(docket.id).customPUT(diff).then(successCb, failureCb);
            }

            /*geolocation.getLocation().then(function(data) {
              var coords = data.coords;
              diff.lat = coords.latitude;
              diff.long = coords.longitude;
              saveDocket(diff, successCb, failureCb);
              //baseDockets.one(docket.id).customPUT(diff).then(successCb, failureCb);
            }, function(err) {
              saveDocket(diff, successCb, failureCb);
              baseDockets.one(docket.id).customPUT(diff).then(successCb, failureCb);
            });*/
          } else {
            var docketObject = {};
            docketObject.status = 'sent';

            if (navigator && navigator.geolocation) {
              navigator.geolocation.getCurrentPosition(function (data) {
                var coords = data.coords;
                docketObject.lat = coords.latitude;
                docketObject.long = coords.longitude;
                baseDockets.one(docket.id).customPUT(docketObject).then(successCb, failureCb);
              }, function (err) {
                baseDockets.one(docket.id).customPUT(docketObject).then(successCb, failureCb);
              }, { enableHighAccuracy: true, timeout: 5000 });
            } else {
              baseDockets.one(docket.id).customPUT(docketObject).then(successCb, failureCb);
            }

            /*geolocation.getLocation().then(function(data) {
              var coords = data.coords;
              docketObject.lat = coords.latitude;
              docketObject.long = coords.longitude;
              baseDockets.one(docket.id).customPUT(docketObject).then(successCb, failureCb);
            }, function(err) {
              baseDockets.one(docket.id).customPUT(docketObject).then(successCb, failureCb);
            });*/
          }
        });
      }
    }

    this.sendDocket = sendDocket;

    var sendDocketPresetGeo = function (docket, geoCoords, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseDockets = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('dockets');

      var docketObject = {};
      docketObject.status = 'sent';

      if (geoCoords) {
        docketObject.lat = geoCoords.latitude;
        docketObject.long = geoCoords.longitude;
      }

      baseDockets.one(docket).customPUT(docketObject).then(successCb, failureCb);
    }

    /***** Send Bulk Dockets *****/
    this.sendBulkDockets = function (dockets, successCb) {
      var failures = [];

      if (navigator && navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (data) {
          var coords = data.coords;

          sendDockets(coords, dockets, 0, failures, function (failuresFilled) {
            successCb(failuresFilled);
          });
        }, function (err) {
          sendDockets(null, dockets, 0, failures, function (failuresFilled) {
            successCb(failuresFilled);
          });
        }, { enableHighAccuracy: true, timeout: 5000 });
      } else {
        sendDockets(null, dockets, 0, failures, function (failuresFilled) {
          successCb(failuresFilled);
        });
      }

      /*geolocation.getLocation().then(function(data) {
        var coords = data.coords;

        sendDockets(coords, dockets, 0, failures, function(failuresFilled) {
          successCb(failuresFilled);
        });
      }, function(err) {
        sendDockets(null, dockets, 0, failures, function(failuresFilled) {
          successCb(failuresFilled);
        });
      });*/
    }

    var sendDockets = function (geoCoords, list, index, failures, successCb) {
      if (index >= list.length) {
        successCb(failures);
        return;
      }
      sendDocketPresetGeo(list[index].id, geoCoords, function (success) {
        sendDockets(geoCoords, list, index + 1, failures, successCb);
      }, function (err) {
        failures.push(list[index]);
        sendDockets(geoCoords, list, index + 1, failures, successCb);
      });
    }

    /**** Reject a docket ****/
    var rejectDocket = function (docket, reason, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseDockets = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('dockets');

      var docketObject = { status: 'rejected', rejectionComment: reason };
      var docketId = docket;
      if (docketId.id != null) {
        docketId = docketId.id;
      }
      baseDockets.one(docketId).customPUT(docketObject).then(successCb, failureCb);
    }

    this.rejectDocket = rejectDocket;

    /***** Delete Reject Dockets *****/
    this.rejectBulkDockets = function (dockets, reason, successCb) {
      var failures = [];
      rejectDockets(dockets, reason, 0, failures, function (failuresFilled) {
        successCb(failuresFilled);
      });
    }

    var rejectDockets = function (list, reason, index, failures, successCb) {
      if (index >= list.length) {
        successCb(failures);
        return;
      }

      rejectDocket(list[index].id, reason, function (success) {
        rejectDockets(list, reason, index + 1, failures, successCb);
      }, function (err) {
        failures.push(list[index]);
        rejectDockets(list, reason, index + 1, failures, successCb);
      });
    }

    /**** Accept a docket ****/
    var acceptDocket = function (docket, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseDockets = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('dockets');

      var docketObject = { status: 'accepted' };
      var docketId = docket;
      if (docketId.id != null) {
        docketId = docketId.id;
      }
      baseDockets.one(docketId).customPUT(docketObject).then(successCb, failureCb);
    }

    this.acceptDocket = acceptDocket;

    this.recallDocket = function (docket, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseDockets = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('dockets');

      var docketObject = { status: 'draft' };
      var docketId = docket;
      if (docketId.id != null) {
        docketId = docketId.id;
      }
      baseDockets.one(docketId).customPUT(docketObject).then(successCb, failureCb);
    }

    /***** Accept Reject Dockets *****/
    this.acceptBulkDockets = function (dockets, successCb) {
      var failures = [];
      acceptDockets(dockets, 0, failures, function (failuresFilled) {
        successCb(failuresFilled);
      });
    }

    var acceptDockets = function (list, index, failures, successCb) {
      if (index >= list.length) {
        successCb(failures);
        return;
      }

      acceptDocket(list[index].id, function (success) {
        acceptDockets(list, index + 1, failures, successCb);
      }, function (err) {
        failures.push(list[index]);
        acceptDockets(list, index + 1, failures, successCb);
      });
    }

    /***** Re-Draft a Docket *****/
    this.reDraftDocket = function (docket, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseDockets = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('dockets');

      var docketObject = { status: 'draft' };
      baseDockets.one(docket.id).customPUT(docketObject).then(successCb, failureCb);
    }

    /******* Get list of dockets ********/
    this.getDockets = function (params, successCb, failureCb) {
      if (params == null) {
        params = {};
      }

      /**** Setup scope - group or myDocketbook ****/
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseDockets = null;

      if (organisationGroup != null) {
        baseDockets = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('dockets');
      } else {
        baseDockets = Restangular.all('dockets');
      }
      /**** End scope setup ****/

      if (params['offset'] != null && params['limit'] != null) {
        baseDockets.customGET("", params).then(successCb, failureCb);
      } else {
        baseDockets.getList(params).then(function (dockets) {
          successCb(Restangular.stripRestangular(dockets));
        }, failureCb);
      }
    }

    /****** Get populated dockets for home feed *******/
    this.populateDocketsForFeed = function (docketsList, cb) {
      populateDocketsFeedData(docketsList, 0, cb);
    }

    var populateDocketsFeedData = function (docketsList, index, cb) {
      if (index >= docketsList.length) {
        cb(docketsList);
        return;
      }

      getDocket(docketsList[index].id, false, function (fullDocket) {
        // generate line summary
        var resourceSummary = { totalInteractions: 0 };
        for (var i = 0; i < fullDocket.resources.length; i++) {
          var resource = fullDocket.resources[i];
          if (resourceSummary[resource.id] == null) {
            resourceSummary[resource.id] = { interactionSummary: {}, resource: resource.resource };
          }
          for (var j = 0; j < resource.interactions.length; j++) {
            if (resourceSummary[resource.id].interactionSummary[resource.interactions[j].interactionTemplate.name] == null) {
              resourceSummary[resource.id].interactionSummary[resource.interactions[j].interactionTemplate.name] = { interaction: resource.interactions[j].interactionTemplate, quantity: resource.interactions[j].quantity };
            } else {
              resourceSummary[resource.id].interactionSummary[resource.interactions[j].interactionTemplate.name].quantity += resource.interactions[j].quantity;
            }
            resourceSummary.totalInteractions += 1;
          }
        }

        fullDocket.resourceSummary = resourceSummary;
        docketsList[index] = fullDocket;
        populateDocketsFeedData(docketsList, index + 1, cb);
      }, function (err) {
        populateDocketsFeedData(docketsList, index + 1, cb);
      });
    }

    /******************/
    /***** Filing *****/
    /******************/

    this.getDocketFileData = function (docket, successCb, failureCb) {
      var currentOrg = accessControl.currentOrg();
      var currentOrgGroup = accessControl.currentOrgGroup();
      var baseDocketFiles = Restangular.all('organisations').one(currentOrg.id).all('groups').one(currentOrgGroup.id).all('docketfiles');

      var docketId = docket;
      if (docket.id != null) {
        docketId = docket.id;
      }

      baseDocketFiles.getList({ 'docket': docketId }).then(function (docketFiles) {
        var existingDocketFile = null;
        var identifiers = {};
        for (var i = 0; i < docketFiles.length; i++) {
          if (docketFiles[i].lineCodes) {
            for (var j = 0; j < docketFiles[i].lineCodes.length; j++) {
              var fileCodeIdentifiers = [];
              if (docketFiles[i].lineCodes[j].fileCodes) {
                fileCodeIdentifiers = Object.keys(docketFiles[i].lineCodes[j].fileCodes);
              }
              for (var k = 0; k < fileCodeIdentifiers.length; k++) {
                if (identifiers[fileCodeIdentifiers[k]] == null) {
                  identifiers[fileCodeIdentifiers[k]] = { placeholder: true };
                }
              }
            }
          }
        }
        // get list of identifiers
        var identifiersList = Object.keys(identifiers);
        // get all fileCodes from identifiers
        if (identifiersList != null && identifiersList.length > 0) {
          getFileCodes({ ids: identifiersList }, function (fileCodes) {
            // convert fileCodes to dictionary for ease of use
            var fileCodesDict = {};
            for (var i = 0; i < fileCodes.length; i++) {
              fileCodesDict[fileCodes[i].uniqueIdentifier] = fileCodes[i];
            }
            // got list of fileCodes - now re-attach back onto the docket Files
            for (var i = 0; i < docketFiles.length; i++) {
              if (docketFiles[i].lineCodes) {
                for (var j = 0; j < docketFiles[i].lineCodes.length; j++) {
                  if (docketFiles[i].lineCodes[j].fileCodes) {
                    var fileCodesKeys = Object.keys(docketFiles[i].lineCodes[j].fileCodes);
                    var populatedFileCodes = [];
                    for (var k = 0; k < fileCodesKeys.length; k++) {
                      var newFileCode = {};
                      newFileCode.fileCode = fileCodesDict[fileCodesKeys[k]];
                      newFileCode.percentage = docketFiles[i].lineCodes[j].fileCodes[fileCodesKeys[k]];
                      populatedFileCodes.push(newFileCode);
                    }
                    docketFiles[i].lineCodes[j].populatedFileCodes = populatedFileCodes;
                  }
                }
              }
            }
            if (docketFiles.length > 0) {
              existingDocketFile = docketFiles[0];
            }
            successCb(existingDocketFile);
          }, function (err) {
            if (docketFiles.length > 0) {
              existingDocketFile = docketFiles[0];
            }
            successCb(existingDocketFile);
          });
        } else {
          if (docketFiles.length > 0) {
            existingDocketFile = docketFiles[0];
          }
          successCb(existingDocketFile);
        }
      }, function (err) {
        failureCb(err);
      });
    }

    this.getBulkDocketFileData = function (docketIds, successCb, failureCb) {
      var currentOrg = accessControl.currentOrg();
      var currentOrgGroup = accessControl.currentOrgGroup();

      if (currentOrg == null || currentOrgGroup == null) {
        if (failureCb) { failureCb() }
        return
      }

      var baseDocketFiles = Restangular.all('organisations').one(currentOrg.id).all('groups').one(currentOrgGroup.id).all('docketfiles');

      var docketIdString = '';
      for (var i = 0; i < docketIds.length; i++) {
        if (i == docketIds.length - 1) {
          docketIdString += docketIds[i];
        } else {
          docketIdString += docketIds[i] + ",";
        }
      }

      baseDocketFiles.getList({ 'dockets': docketIdString }).then(function (docketFiles) {
        // get list of fileCodes used by all docketFiles
        var identifiers = {};
        for (var i = 0; i < docketFiles.length; i++) {
          if (docketFiles[i].lineCodes) {
            for (var j = 0; j < docketFiles[i].lineCodes.length; j++) {
              var fileCodeIdentifiers = [];
              if (docketFiles[i].lineCodes[j].fileCodes) {
                fileCodeIdentifiers = Object.keys(docketFiles[i].lineCodes[j].fileCodes);
              }
              for (var k = 0; k < fileCodeIdentifiers.length; k++) {
                if (identifiers[fileCodeIdentifiers[k]] == null) {
                  identifiers[fileCodeIdentifiers[k]] = { placeholder: true };
                }
              }
            }
          }
        }
        // get list of identifiers
        var identifiersList = Object.keys(identifiers);
        // get all fileCodes from identifiers
        var identifiersParsed = [];
        for (var i = 0; i < identifiersList.length; i++) {
          if (identifiersList[i] != null && identifiersList[i] != undefined && identifiersList[i].length > 10) {
            identifiersParsed.push(identifiersList[i]);
          }
        }
        if (identifiersParsed.length == 0) {
          successCb(docketFiles)
          return;
        }
        getFileCodes({ ids: identifiersParsed }, function (fileCodes) {
          // convert fileCodes to dictionary for ease of use
          var fileCodesDict = {};
          for (var i = 0; i < fileCodes.length; i++) {
            fileCodesDict[fileCodes[i].uniqueIdentifier] = fileCodes[i];
          }
          // got list of fileCodes - now re-attach back onto the docket Files
          for (var i = 0; i < docketFiles.length; i++) {
            if (docketFiles[i].lineCodes) {
              for (var j = 0; j < docketFiles[i].lineCodes.length; j++) {
                if (docketFiles[i].lineCodes[j].fileCodes) {
                  var fileCodesKeys = Object.keys(docketFiles[i].lineCodes[j].fileCodes);
                  var populatedFileCodes = [];
                  for (var k = 0; k < fileCodesKeys.length; k++) {
                    var newFileCode = {};
                    newFileCode.fileCode = fileCodesDict[fileCodesKeys[k]];
                    newFileCode.percentage = docketFiles[i].lineCodes[j].fileCodes[fileCodesKeys[k]];
                    populatedFileCodes.push(newFileCode);
                  }
                  docketFiles[i].lineCodes[j].populatedFileCodes = populatedFileCodes;
                }
              }
            }
          }
          successCb && successCb(docketFiles);
        }, function (err) {
          successCb && successCb(docketFiles);
        });
      }, function (err) {
        failureCb && failureCb(err);
      });
    }

    /****** Get File Codes *******/
    var getFileCodes = function (params, successCb, failureCb) {
      var currentOrg = accessControl.currentOrg();
      var currentOrgGroup = accessControl.currentOrgGroup();
      var orgGroupId = currentOrgGroup.id;
      if (params.orgGroupId) {
        orgGroupId = params.orgGroupId;
      }
      var baseFileCodes = Restangular.all('organisations').one(currentOrg.id).all('groups').one(orgGroupId).all('filecodes');

      if (params == null) {
        params = {};
      }
      if (params.ids != null) {
        params.ids = params.ids.join(',');
      }

      baseFileCodes.getList(params).then(function (fileCodes) {
        var fileCodesStripped = [];
        for (var i = 0; i < fileCodes.length; i++) {
          fileCodesStripped.push(Restangular.stripRestangular(fileCodes[i]));
        }
        successCb(fileCodesStripped);
      }, failureCb);

    }

    this.getFileCodes = getFileCodes;

    /***** Get File Code *****/
    this.getFileCode = function (fileCode, successCb, failureCb) {
      var currentOrg = accessControl.currentOrg();
      var currentOrgGroup = accessControl.currentOrgGroup();
      var baseFileCodes = Restangular.all('organisations').one(currentOrg.id).all('groups').one(currentOrgGroup.id).all('filecodes');

      var uniqueIdentifier = fileCode;
      if (fileCode.uniqueIdentifier != null) {
        uniqueIdentifier = fileCode.uniqueIdentifier;
      }

      baseFileCodes.one(uniqueIdentifier).get().then(successCb, failureCb);
    }

    /***** Save File Code *****/
    this.saveFileCode = function (fileCode, successCb, failureCb) {
      var currentOrg = accessControl.currentOrg();
      var currentOrgGroup = accessControl.currentOrgGroup();
      var orgGroupId = currentOrgGroup.id;
      if (fileCode.orgGroupId) {
        orgGroupId = fileCode.orgGroupId;
      }
      var baseFileCodes = Restangular.all('organisations').one(currentOrg.id).all('groups').one(orgGroupId).all('filecodes');

      if (fileCode.id == null) {
        fileCode.organisation = currentOrg.id;
        fileCode.organisationGroup = orgGroupId;

        baseFileCodes.post(fileCode).then(successCb, failureCb);
      } else {
        baseFileCodes.one(fileCode.uniqueIdentifier).customPUT(fileCode).then(successCb, failureCb);
      }
    }

    /********* Delete File Code **********/
    var deleteFileCode = function (orgGroupId, fileCodeId, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseFileCodes = Restangular.all('organisations').one(organisation.id).all('groups').one(orgGroupId).all('filecodes');

      if (fileCodeId.uniqueIdentifier != null) {
        fileCodeId = fileCodeId.uniqueIdentifier;
      }

      baseFileCodes.one(fileCodeId).remove().then(successCb, failureCb);
    }

    this.deleteFileCode = deleteFileCode;

    /********** Delete Bulk File Codes **********/
    this.deleteBulkFileCodes = function (orgGroupId, fileCodes, successCb) {
      var failures = [];
      deleteFileCodes(orgGroupId, fileCodes, 0, failures, function (failuresFilled) {
        successCb(failuresFilled);
      });
    }

    var deleteFileCodes = function (orgGroupId, list, index, failures, successCb) {
      if (index >= list.length) {
        successCb(failures);
        return;
      }

      deleteFileCode(orgGroupId, list[index].uniqueIdentifier, function (success) {
        deleteFileCodes(orgGroupId, list, index + 1, failures, successCb);
      }, function (err) {
        failures.push(list[index]);
        deleteFileCodes(orgGroupId, list, index + 1, failures, successCb);
      });
    }

    /***** Import Bulk File Codes *****/
    this.importFileCodes = function (orgGroupId, fileCodes, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseFileCodeImport = Restangular.all('organisations').one(organisation.id).all('groups').one(orgGroupId).all('filecodes?import=true');

      baseFileCodeImport.customPOST(fileCodes).then(successCb, failureCb);
    }

    /***** Save Docket Filing *****/
    this.saveDocketFiling = function (docketFiling, successCb, failureCb) {
      var dockets = docketFiling.dockets;
      var method = docketFiling.method;

      var currentOrg = accessControl.currentOrg();
      var currentOrgGroup = accessControl.currentOrgGroup();
      var baseDocketFiles = Restangular.all('organisations').one(currentOrg.id).all('groups').one(currentOrgGroup.id).all('docketfiles');

      var docketFilesToSave = [];
      for (var i = 0; i < dockets.length; i++) {
        // Basic docketFile setup for this docket
        var docketFile = {};
        docketFile.fileMethod = docketFiling.method;
        docketFile.docketRef = dockets[i].id;
        if (dockets[i].orderRef) {
          if (dockets[i].orderRef.id) {
            docketFile.orderRef = dockets[i].orderRef.id;
          } else {
            docketFile.orderRef = dockets[i].orderRef;
          }
        }
        if (dockets[i].jobRef) {
          if (dockets[i].jobRef.id) {
            docketFile.jobRef = dockets[i].jobRef.id;
          } else {
            docketFile.jobRef = dockets[i].jobRef;
          }
        }
        docketFile.organisation = currentOrg.id;
        docketFile.organisationGroup = currentOrgGroup.id;

        // Check if docket has an existing docketFile
        if (dockets[i].existingDocketFile) {
          docketFile.fromExisting = dockets[i].existingDocketFile;
          docketFile.id = docketFile.fromExisting.id;
        } else {
          docketFile.fromExisting = null;
        }

        // Create master fileCode if method is docket or split
        var masterFileCode = null;
        if (method == 'docket') {
          masterFileCode = {};
          masterFileCode[docketFiling.activityCode.uniqueIdentifier] = 100;
        } else if (method == 'split') {
          masterFileCode = {};
          if (docketFiling.activityCodes) {
            for (var j = 0; j < docketFiling.activityCodes.length; j++) {
              masterFileCode[docketFiling.activityCodes[j].fileCode.uniqueIdentifier] = parseFloat(docketFiling.activityCodes[j].splitPercentage);
            }
          }
        }

        docketFile.lineCodes = [];
        if (docketFile.fromExisting) {
          docketFile.lineCodes = docketFile.fromExisting.lineCodes;
        }
        for (var j = 0; j < dockets[i].resources.length; j++) {
          for (var k = 0; k < dockets[i].resources[j].interactions.length; k++) {
            var thisInteraction = dockets[i].resources[j].interactions[k];
            // generate fileCodes object for this interaction
            var fileCodes = {};
            if (docketFiling.method == 'docket' || docketFiling.method == 'split') {
              fileCodes = masterFileCode;
            } else {
              // locate lineCode from linesSummary and set fileCodes object
              if (dockets.length == 1) {
                for (var l = 0; l < docketFiling.linesSummary.length; l++) {
                  if (docketFiling.linesSummary[l].interaction.id == thisInteraction.id && docketFiling.linesSummary[l].resource.id == thisInteraction.resource.id) {
                    fileCodes = {};
                    for (var dc = 0; dc < docketFiling.linesSummary[l].activityCodes.length; dc++) {
                      const activityCode = docketFiling.linesSummary[l].activityCodes[dc]
                      fileCodes[activityCode.fileCode.uniqueIdentifier] = activityCode.percentage;
                    }
                    break;
                  }
                }
              } else {
                for (var l = 0; l < docketFiling.linesSummary.length; l++) {
                  if (docketFiling.linesSummary[l].interaction.interactionName == thisInteraction.interactionName && docketFiling.linesSummary[l].resource.id == thisInteraction.resource.id) {
                    fileCodes = {};
                    if (docketFiling.linesSummary[l].activityCodes) {
                      for (var dc = 0; dc < docketFiling.linesSummary[l].activityCodes.length; dc++) {
                        const activityCode = docketFiling.linesSummary[l].activityCodes[dc]
                        fileCodes[activityCode.fileCode.uniqueIdentifier] = activityCode.percentage;
                      }
                    }
                    break;
                  }
                }
              }
            }

            // if existing docketFile - check if lineCode already exists for this interaction
            var matched = false;
            for (var l = 0; l < docketFile.lineCodes.length; l++) {
              if (docketFile.lineCodes[l].interaction.id == thisInteraction.id && docketFile.lineCodes[l].resource.id == thisInteraction.resource.id) {
                // lineCode matches - replace
                matched = true;
                docketFile.lineCodes[l].fileCodes = fileCodes;
                break;
              }
            }

            // if interaction not already added as a lineCode - create a new one
            if (!matched) {
              var lineCode = {};
              lineCode.interaction = thisInteraction;
              lineCode.resource = thisInteraction.resource;
              lineCode.quantity = thisInteraction.quantity;
              lineCode.fileCodes = fileCodes;
              docketFile.lineCodes.push(lineCode);
            }
          }
        }
        docketFilesToSave.push(docketFile);
      }

      // Now save the docket files
      saveBulkDocketFiles(docketFilesToSave, 0, function () {
        successCb();
      });
    }

    var saveBulkDocketFiles = function (docketFiles, index, cb) {
      var currentOrg = accessControl.currentOrg();
      var currentOrgGroup = accessControl.currentOrgGroup();
      var baseDocketFiles = Restangular.all('organisations').one(currentOrg.id).all('groups').one(currentOrgGroup.id).all('docketfiles');

      if (index >= docketFiles.length) {
        cb();
        return;
      }

      var docketFileSave = docketFiles[index];
      if (docketFileSave.fromExisting) {
        baseDocketFiles.one(docketFileSave.fromExisting.id).customPUT(docketFileSave).then(function () {
          saveBulkDocketFiles(docketFiles, index + 1, cb);
        }, function (err) {
          saveBulkDocketFiles(docketFiles, index + 1, cb);
        });
      } else {
        baseDocketFiles.customPOST(docketFileSave).then(function () {
          saveBulkDocketFiles(docketFiles, index + 1, cb);
        }, function (err) {
          saveBulkDocketFiles(docketFiles, index + 1, cb);
        });
      }
    }

    /***************************/
    /**** Helper Functions *****/
    /***************************/

    var setupDocketResourceInteractionStore = function (docket) {
      if (docket.resources != null) {
        for (var i = 0; i < docket.resources.length; i++) {
          if (docket.resources[i].interactions != null) {
            for (var j = 0; j < docket.resources[i].interactions.length; j++) {
              if (docket.resources[i].interactions[j].interactionTemplate.fields != null) {
                for (var k = 0; k < docket.resources[i].interactions[j].interactionTemplate.fields.length; k++) {
                  var field = docket.resources[i].interactions[j].interactionTemplate.fields[k];
                  // check that a value exists in the custom field first
                  if (field.type == 'date' && docket.resources[i].interactions[j].customFields && docket.resources[i].interactions[j].customFields[field.id]) {
                    var dateIn = moment(docket.resources[i].interactions[j].customFields[field.id].split('T')[0]).toDate();
                    docket.resources[i].interactions[j].customFields[field.id] = dateIn;
                  } else if (field.type == 'time' && docket.resources[i].interactions[j].customFields) {
                    docket.resources[i].interactions[j].customFields[field.id] =
                      docket.resources[i].interactions[j].customFields[field.id]
                        ? moment.tz(docket.resources[i].interactions[j].customFields[field.id], docket.timezone)
                        : null;
                  }
                }
              }
            }
          }
        }
      }
    }

    this.setupResourceInteractionStore = setupDocketResourceInteractionStore;

    var setupDocketValueStore = function (docket, cb) {
      if (docket.templateValueStore == null) {
        docket.templateValueStore = {};
      }

      if (docket.template != null && docket.template.blocks != null) {
        docket.template.blocks.forEach(function (block) {
          block.fields.forEach(function (field) {
            var keyStore = block.id + '-' + field.id;

            // patch for fixing bug where multiple of the same option are listed in a select field type
            if (field.type == 'select') {
              var selectionFieldsCleaned = [];
              for (var l = 0; l < field.selectionFields.length; l++) {
                if (selectionFieldsCleaned.indexOf(field.selectionFields[l]) == -1) {
                  selectionFieldsCleaned.push(field.selectionFields[l]);
                }
              }
              field.selectionFields = selectionFieldsCleaned;
            }

            if (docket.templateValueStore[keyStore] == null) {
              docket.templateValueStore[keyStore] = "";
            } else if (field.type == 'date' || field.type == 'datetime') {
              // field is date/datetime or time type - so convert to js date from ISO String
              var beforeValue = docket.templateValueStore[keyStore];
              if (beforeValue != "" && beforeValue != null) {
                docket.templateValueStore[keyStore] = moment(beforeValue).toDate();
              }
            } else if (field.type == 'time') {
              // field is date/datetime or time type - so convert to js date from ISO String
              var beforeValue = docket.templateValueStore[keyStore];
              if (beforeValue != "" && beforeValue != null) {
                docket.templateValueStore[keyStore] = moment.tz(beforeValue, docket.timezone);
              }
            }
          });
        });
        if (cb) {
          cb();
        }
      } else {
        if (cb) {
          cb();
        }
      }
    }

    this.setupValueStore = setupDocketValueStore;

    var setupDocketChecklists = function (docket, cb) {
      var currentOrg = accessControl.currentOrg();
      var currentUser = accessControl.currentUser();
      if (docket.checklists == null) {
        docket.checklists = {};
      }

      if (docket.template != null && docket.template.checklistContainers != null) {
        for (var i = 0; i < docket.template.checklistContainers.length; i++) {
          docket.template.checklistContainers[i].detailOpen = false;
          if (docket.checklists[docket.template.checklistContainers[i].checklistTemplate.id] == null) {
            var newChecklist = {};
            newChecklist.checklistTemplate = docket.template.checklistContainers[i].checklistTemplate.id;
            newChecklist.date = new Date(); // TODO: change this to date when the checklist is filled out
            newChecklist.organisation = accessControl.currentOrg().id;
            newChecklist.author = accessControl.currentUser().id;
            newChecklist.answers = {};
            for (var j = 0; j < docket.template.checklistContainers[i].checklistTemplate.fields.length; j++) {
              newChecklist.answers[docket.template.checklistContainers[i].checklistTemplate.fields[j].id] = "";
            }
            docket.checklists[docket.template.checklistContainers[i].checklistTemplate.id] = newChecklist;
          }
        }
      }

      // check if any once daily checklists have existing answers
      if (docket.id == null && docket.template && docket.template.checklistContainers != null && accessControl.userHasPermission('io.docketbook.ojdapi.getChecklists')) {
        // get all once daily results for this template/user/date
        Restangular.all('organisations/' + currentOrg.id + '/checklists?organisation=' + currentOrg.id + "&author=" + currentUser.id + "&date=" + moment().toISOString()).getList().then(function (checklists) {
          var existingChecklists = Restangular.stripRestangular(checklists);
          for (var i = 0; i < docket.template.checklistContainers.length; i++) {
            for (var j = 0; j < existingChecklists.length; j++) {
              if (docket.template.checklistContainers[i].checklistTemplate.id == existingChecklists[j].checklistTemplate.id) {
                // add answers to checklst item
                if (docket.checklists[existingChecklists[j].checklistTemplate.id] != null) {
                  docket.checklists[existingChecklists[j].checklistTemplate.id].answers = existingChecklists[j].answers;
                }
                break;
              }
            }
          }
          if (cb) {
            cb();
          }
        }, function (err) {
          if (cb) {
            cb();
          }
        });
      } else {
        if (cb) {
          cb();
        }
      }
    }

    this.setupChecklists = setupDocketChecklists;

    var autoPopulateResources = function (docket, populateInteractions, cb) {
      if (docket.jobRef != null) {
        // if from job - populate from job line items
        docket.resources = [];
        for (var i = 0; i < docket.jobRef.lineItems.length; i++) {
          if (docket.jobRef.lineItems[i].resource != null) {
            var newResource = {};
            newResource.resource = docket.jobRef.lineItems[i].resource;
            newResource.description = docket.jobRef.lineItems[i].itemDescription;
            newResource.orderItemId = docket.jobRef.lineItems[i].id;
            newResource.interactions = [];
            // get interactions for resource - to auto populate if possible
            if (docket.template && docket.template.interactionTemplates && populateInteractions == true) {
              var resourceInteractionTemplates = [];
              for (var j = 0; j < docket.template.interactionTemplates.length; j++) {
                var currInteractionTemplate = docket.template.interactionTemplates[j];
                for (var k = 0; k < currInteractionTemplate.actorCategories.length; k++) {
                  if (currInteractionTemplate.actorCategories[k].id == newResource.resource.categoryId && currInteractionTemplate.refersParent == true) {
                    resourceInteractionTemplates.push(currInteractionTemplate);
                    break;
                  }
                }
              }
              if (resourceInteractionTemplates.length == 1) {
                var newInteraction = {};
                newInteraction.interactionName = resourceInteractionTemplates[0].name;
                newInteraction.interactionTemplate = resourceInteractionTemplates[0];
                newInteraction.resource = newResource.resource;
                newInteraction.resourceIsParent = true;
                if (docket.jobRef.lineItems[i].quantity) {
                  newInteraction.quantity = docket.jobRef.lineItems[i].quantity;
                } else {
                  newInteraction.quantity = 0;
                }
                newResource.interactions.push(newInteraction);
              }
            }
            docket.resources.push(newResource);
          }
        }
      } else if (docket.orderRef != null) {
        // if from order - populate from order line items
        if (docket.orderRef.lineItems && (docket.resources == null || docket.resources.length == 0)) {
          docket.resources = [];
          for (var i = 0; i < docket.orderRef.lineItems.length; i++) {
            if (docket.orderRef.lineItems[i].resource != null) {
              var newResource = {};
              newResource.resource = docket.orderRef.lineItems[i].resource;
              newResource.description = docket.orderRef.lineItems[i].itemDescription;
              newResource.orderItemId = docket.orderRef.lineItems[i].id;
              newResource.interactions = [];
              // get interactions for resource - to auto populate if possible
              if (docket.template && docket.template.interactionTemplates && populateInteractions == true) {
                var resourceInteractionTemplates = [];
                for (var j = 0; j < docket.template.interactionTemplates.length; j++) {
                  var currInteractionTemplate = docket.template.interactionTemplates[j];
                  for (var k = 0; k < currInteractionTemplate.actorCategories.length; k++) {
                    if (currInteractionTemplate.actorCategories[k].id == newResource.resource.categoryId && currInteractionTemplate.refersParent == true) {
                      resourceInteractionTemplates.push(currInteractionTemplate);
                      break;
                    }
                  }
                }
                if (resourceInteractionTemplates.length == 1) {
                  var newInteraction = {};
                  newInteraction.interactionName = resourceInteractionTemplates[0].name;
                  newInteraction.interactionTemplate = resourceInteractionTemplates[0];
                  newInteraction.resource = newResource.resource;
                  newInteraction.resourceIsParent = true;
                  newInteraction.quantity = docket.orderRef.lineItems[i].quantity;
                  newResource.interactions.push(newInteraction);
                }
              }
              docket.resources.push(newResource);
            }
          }
        }
      }
      if (cb) {
        cb();
      }
    }

    this.autoPopulateResources = autoPopulateResources;

    var updateDocketRefs = function (docket, successCb) {
      var currentOrg = accessControl.currentOrg();
      var currentOrgGroup = accessControl.currentOrgGroup();

      if (docket.orderRef != null) {
        // update customer contacts
        if (docket.orderRef.customerContact != null) {
          docket.customerContact = angular.copy(docket.orderRef.customerContact);
        } else {
          delete docket.customerContact;
        }
        // update supplier contact
        if (docket.orderRef.supplierContact != null) {
          docket.supplierContact = angular.copy(docket.orderRef.supplierContact);
        }// else {
        //delete docket.supplierContact;
        //}
        // update docket template
        if (docket.orderRef.template != null && currentOrg != null) {
          // check if orderRef template is populated
          if (docket.orderRef.template.id != null) {
            docket.template = angular.copy(docket.orderRef.template);
            updateDocketStores(docket, successCb);
          } else {
            // get full template
            var templateId = docket.orderRef.template;
            this.getTemplate(templateId, function (templateFull) {
              docket.template = Restangular.stripRestangular(templateFull);
              updateDocketStores(docket, successCb);
            });
          }
        }
        if (docket.orderRef.supplierRefNo != null) {
          docket.supplierRefNo = docket.orderRef.supplierRefNo;
        }
        if (docket.orderRef.customerRefNo != null) {
          docket.customerRefNo = docket.orderRef.customerRefNo;
        }
      } else {
        if (currentOrgGroup != null && currentOrgGroup.defaultTemplate != null) {
          this.getTemplate(currentOrgGroup.defaultTemplate, function (templateFull) {
            docket.template = Restangular.stripRestangular(templateFull);
            updateDocketStores(docket, successCb);
          });
        }
      }
    }

    this.updateDocketRefs = updateDocketRefs;

    var updateDocketStores = function (docket, successCb) {
      setupDocketValueStore(docket, function () {
        setupDocketChecklists(docket, function () {
          if (docket.orderRef != null) {
            var populateInteractions = false;
            if (docket.template != null && docket.template.populateResourcesFromJob) {
              populateInteractions = true;
            }
            autoPopulateResources(docket, populateInteractions, function () {
              if (successCb) {
                successCb(docket);
              }
            });
          } else {
            if (successCb) {
              successCb(docket);
            }
          }
        });
      });
    }

    this.updateDocketStores = updateDocketStores;

    var validateChecklists = function (docket) {
      var checklistsWithErrors = [];
      if (docket.template && docket.template.checklistContainers) {
        for (var i = 0; i < docket.template.checklistContainers.length; i++) {
          // check if there are checklist values for this checklist template
          var checklistTemplate = docket.template.checklistContainers[i].checklistTemplate;
          var checklistIncomplete = false;
          if (docket.checklists[checklistTemplate.id] != null) {
            // a checklist object exists for this checklist template - check if each question has an answer
            var checklistObject = docket.checklists[checklistTemplate.id];
            for (var j = 0; j < checklistTemplate.fields.length; j++) {
              // check if field has an answer in checklistObject
              if (checklistObject.answers[checklistTemplate.fields[j].id] == null || checklistObject.answers[checklistTemplate.fields[j].id] == "") {
                checklistIncomplete = true;
              }
            }
          } else {
            checklistIncomplete = true;
          }

          if ((checklistIncomplete) && (docket.checklists[checklistTemplate.id])) {
            docket.checklists[checklistTemplate.id].complete = false;
            if (docket.template.checklistContainers[i].rule == "required") {
              checklistsWithErrors.push(checklistTemplate.id);
            }
          } else if ((checklistIncomplete) && (!docket.checklists[checklistTemplate.id])) {
            if (docket.template.checklistContainers[i].rule == "required") {
              checklistsWithErrors.push(checklistTemplate.id);
            }
          } else {
            docket.checklists[checklistTemplate.id].complete = true;
          }
        }
      }

      return checklistsWithErrors;
    }

    this.validateChecklists = validateChecklists;

    var validateDocket = function (docket, successCb, failureCb) {
      var checklistsWithErrors = validateChecklists(docket);
      var errors = [];
      if (checklistsWithErrors.length > 0) {
        var errorNew = { name: 'checklists', detail: 'Some checklists that are required have not been completed fully.' };
        errors.push(errorNew);
      }

      // Validate custom block fields
      for (var i = 0; i < docket.template.blocks.length; i++) {
        var block = docket.template.blocks[i];
        // validate custom blocks
        if (block.type == 'custom') {
          // check if any fields are mandatory and have values
          var blockHasErrors = false;
          for (var j = 0; j < block.fields.length; j++) {
            var field = block.fields[j];
            var fieldValue = docket.templateValueStore[block.id + '-' + field.id];
            if (field.mandatory && (fieldValue === null || fieldValue === '')) {
              blockHasErrors = true;
            }
          }
          if (blockHasErrors) {
            var newError = { name: 'customFields', detail: 'Some mandatory fields have not been completed.' };
            errors.push(newError);
          }
        }

        // validate time block
        /*if ( block.type == 'time' ) {
          // docket has time block, new check if time values have been entered
          if ( docket.startTime == null || docket.startTime == "" || docket.endTime == null || docket.endTime == "" ) {
            var errorNew = {name:'times', detail:'Start and end time are required before submission.'};
            errors.push(errorNew);
          }
        }*/

        // validate signature block
        if (block.type == 'signatures') {
          if (docket.template.signature) {
            // check customer signature
            if ((docket.customerSignature == null || docket.customerSignature == "") && (docket.customerSignatureImage == null || docket.customerSignatureImage == "")) {
              var errorNew = { name: 'customerSignature', detail: 'Customer signature is required before submission.' };
              errors.push(errorNew);
            }
            if ((docket.supplierSignature == null || docket.supplierSignature == "") && (docket.supplierSignatureImage == null || docket.supplierSignatureImage == "")) {
              var errorNew = { name: 'operatorSignature', detail: 'Operator signature is required before submission.' };
              errors.push(errorNew);
            }
          }
        }

        // validate items block
        if (block.type == 'resources') {
          // TODO: validate if minimumInteractionRequired

          if (docket.template.minimumInteractionRequired == true) {
            var interactionsCount = 0;
            for (var j = 0; j < docket.resources.length; j++) {
              for (var k = 0; k < docket.resources[j].interactions.length; k++) {
                interactionsCount += 1;
              }
            }
            if (interactionsCount <= 0) {
              var errorNew = { name: 'minimumInteractionRequired', detail: 'At least one interaction is required before submission.' };
              errors.push(errorNew);
            }
          }
        }
      }

      // VALIDATE CUSTOMER
      if (docket.customer == null && docket.customerContact == null) {
        var errorNew = { name: 'customer', detail: 'A customer must be added before sending the docket' };
        errors.push(errorNew);
      }

      if (errors.length > 0) {
        failureCb(errors);
      } else {
        successCb();
      }
    }

    this.validateDocket = validateDocket;

    // Get diff between original and changed docket
    var getDiffedDocket = function (original, modified, method, cb) {
      if (!original || !modified) {
        cb(null);
      }
      var basicFields = [];
      basicFields.push({ name: 'date', type: 'date' });
      basicFields.push({ name: 'startTime', type: 'time' });
      basicFields.push({ name: 'endTime', type: 'time' });
      basicFields.push({ name: 'breakTime', type: 'int' });
      basicFields.push({ name: 'travelTime', type: 'int' });
      basicFields.push({ name: 'customerSignatureData', type: 'string' });
      basicFields.push({ name: 'customerSignatureName', type: 'string' });
      basicFields.push({ name: 'supplierSignatureData', type: 'string' });
      basicFields.push({ name: 'supplierRefNo', type: 'string' });
      basicFields.push({ name: 'customerRefNo', type: 'string' });
      var complexObjects = ['template', 'customerContact'];//, 'additionalContacts'];
      var diffedDocket = {};
      diffedDocket.id = original.id;
      diffedDocket.organisation = original.organisation;
      diffedDocket.organisationGroup = original.organisationGroup;
      var diffCount = 0;
      // Check if any listed fields have changed
      /*
      if (modified['additionalContacts'] !== original['additionalContacts']) {
        diffedDocket['additionalContacts'] = modified['additionalContacts'];
        diffCount += 1;
      }*/
      for (var i = 0; i < basicFields.length; i++) {
        var fieldName = basicFields[i].name;
        var fieldType = basicFields[i].type;
        if (original[fieldName] == null && modified[fieldName] != null) {
          diffedDocket[fieldName] = modified[fieldName];
          diffCount += 1;
        } else if (original[fieldName] != null && modified[fieldName] == null) {
          diffedDocket[fieldName] = null;
          diffCount += 1;
        } else if (original[fieldName] == null && modified[fieldName] == null) {
          // field is the same - no changes
        } else {
          if (fieldType == 'date') {
            let diff = false;
            try {
              if ((original[fieldName] ? original[fieldName].getTime() : null) !== (modified[fieldName] ? modified[fieldName].getTime() : null)) {
                diff = true;
              }
            } catch (err) {
              diff = original[fieldName] !== modified[fieldName];
            }
            if (diff) {
              diffedDocket[fieldName] = modified[fieldName];
              diffCount += 1;
            }
          } else if (fieldType == 'time') {
            let diff = false;
            try {
              if ((original[fieldName] ? original[fieldName].toDate().getTime() : null) !== (modified[fieldName] ? modified[fieldName].toDate().getTime() : null)) {
                diff = true;
              }
            } catch (err) {
              diff = original[fieldName] !== modified[fieldName];
            }
            if (diff) {
              diffedDocket[fieldName] = modified[fieldName];
              diffCount += 1;
            }
          } else {
            if (original[fieldName] !== modified[fieldName]) {
              diffedDocket[fieldName] = modified[fieldName];
              diffCount += 1;
            }
          }
        }
      }

      // Check if any listed objects have changed
      for (var i = 0; i < complexObjects.length; i++) {
        var objectCheck = complexObjects[i];
        if (original[objectCheck] == null && modified[objectCheck] != null) {
          diffedDocket[objectCheck] = modified[objectCheck];
          diffCount += 1;
        } else if (original[objectCheck] != null && modified[objectCheck] == null) {
          diffedDocket[objectCheck] = null;
          diffCount += 1;
        } else if (original[objectCheck] == null && modified[objectCheck] == null) {
          // object is the same - no changes
        } else if (original[objectCheck].id != modified[objectCheck].id) {
          diffedDocket[objectCheck] = modified[objectCheck];
          diffCount += 1;
        }
      }
      // Check if orderRef has changed
      var orderRefChanged = false;
      if (original.orderRef == null && modified.orderRef != null) {
        orderRefChanged = true;
      } else if (original.orderRef != null && modified.orderRef == null) {
        orderRefChanged = true;
      } else if (original.orderRef == null && modified.orderRef == null) {
        // no change - leave
      } else if (original.orderRef.id != modified.orderRef.id) {
        orderRefChanged = true;
      }

      if (orderRefChanged) {
        diffCount += 1;
        diffedDocket.orderRef = modified.orderRef;
        diffedDocket.customerContact = modified.customerContact;
        diffedDocket.supplierContact = modified.supplierContact;
      }

      // check additional contacts
      if (original.additionalContacts.length != modified.additionalContacts.length) {
        diffedDocket['additionalContacts'] = modified['additionalContacts'];
        diffCount += 1;
      }

      if (original.resources == null) {
        original.resources = [];
      }
      if (modified.resources == null) {
        modified.resources = [];
      }

      // Check Resources
      if (true) { //method && method == 'resources'
        if (original.resources.length != modified.resources.length) {
          // there is definitely a change - send entire resources array to update
          diffedDocket.resources = modified.resources;
          diffCount += 1;
        } else {
          // check each element in resources array to check if there are any changes
          //var changesDetected = false;
          var resourcesModified = [];
          for (var i = 0; i < original.resources.length; i++) {
            var originalResource = original.resources[i];
            var modifiedResource = modified.resources[i];

            if (originalResource.resource.id != modifiedResource.resource.id) {
              // resource is different - updates!
              //changesDetected = true;
              resourcesModified.push(modifiedResource);
              break;
            } else if (modifiedResource.delete == true) {
              //changesDetected = true;
              resourcesModified.push(modifiedResource);
            } else if (modifiedResource.interactions.length != originalResource.interactions.length) {
              resourcesModified.push(modifiedResource);
            } else if (modifiedResource.orderItemId != originalResource.orderItemId) {
              resourcesModified.push(modifiedResource);
            } else {
              var interactionsModified = [];
              for (var j = 0; j < modifiedResource.interactions.length; j++) {
                var originalInteraction = originalResource.interactions[j];
                var modifiedInteraction = modifiedResource.interactions[j];
                if (modifiedInteraction.id == null || modifiedInteraction.id != originalInteraction.id) {
                  interactionsModified.push(modifiedInteraction);
                  break;
                } else if (modifiedInteraction.delete && modifiedInteraction.delete == true) {
                  //changesDetected = true;
                  interactionsModified.push(modifiedInteraction);
                  break;
                } else if (originalInteraction.quantity != modifiedInteraction.quantity) {
                  // quantities have changed on the interaction - do updates
                  //changesDetected = true;
                  interactionsModified.push(modifiedInteraction);
                  break;
                } else if (originalInteraction.interactionTemplate.id != modifiedInteraction.interactionTemplate.id) {
                  // interaction templates have changed - do updates
                  //changesDetected = true;
                  interactionsModified.push(modifiedInteraction);
                  break;
                } else if (originalInteraction.interactionTemplate.refersParent == false &&
                  originalInteraction.resource.id != modifiedInteraction.resource.id) {
                  // interaction resource has changed (complex interaction only)
                  // do updates
                  //changesDetected = true;
                  interactionsModified.push(modifiedInteraction);
                  break;
                } else {
                  // check custom field changes
                  var originalCustomFields = [];
                  var modifiedCustomFields = [];
                  if (originalInteraction.customFields) {
                    originalCustomFields = Object.keys(originalInteraction.customFields);
                  }
                  if (modifiedInteraction.customFields) {
                    modifiedCustomFields = Object.keys(modifiedInteraction.customFields);
                  }
                  if (originalCustomFields.length != modifiedCustomFields.length) {
                    // custom fields have definitely changed - do update
                    //changesDetected = true;
                    interactionsModified.push(modifiedInteraction);
                    break;
                  } else {
                    // check if any values have changed inside each field
                    var customFieldChanges = false;
                    for (var k = 0; k < originalCustomFields.length; k++) {
                      var key = originalCustomFields[k];

                      const fielsAreMoments = isMoment(originalInteraction.customFields[key])
                      if (
                        (fielsAreMoments && !(originalInteraction.customFields[key]).isSame(modifiedInteraction.customFields[key]))
                        || (!fielsAreMoments && originalInteraction.customFields[key] != modifiedInteraction.customFields[key])
                      ) {
                        customFieldChanges = true;
                        //changesDetected = true;
                        break;
                      }
                    }

                    if (customFieldChanges) {
                      //changesDetected = true;
                      interactionsModified.push(modifiedInteraction);
                      break;
                    }
                  }
                }
              }

              if (interactionsModified.length > 0) {
                resourcesModified.push(modifiedResource);
              }
            }
          }

          if (resourcesModified.length > 0) {
            diffedDocket.resources = resourcesModified;
            diffCount += 1;
          }
        }
      }

      if (original.template && modified.template) {
        // check templateValueStore for custom blocks fields
        var originalValueStoreKeys = Object.keys(original.templateValueStore);
        var modifiedValueStoreKeys = Object.keys(modified.templateValueStore);
        if (originalValueStoreKeys.length != modifiedValueStoreKeys.length) {
          // changes definitely made - do update
          diffedDocket.templateValueStore = modified.templateValueStore;
          diffedDocket.template = modified.template;
          diffCount += 1;
        } else {
          // check value of each template value store item
          var templateChanges = false;
          for (var i = 0; i < original.template.blocks.length; i++) {
            if (original.template.blocks[i].type == 'custom') {
              // custom block - check if templateValueStore values have changed
              var thisBlock = original.template.blocks[i];
              var blockChanges = false;
              for (var j = 0; j < thisBlock.fields.length; j++) {
                var thisField = thisBlock.fields[j];
                var originalValue = original.templateValueStore[thisBlock.id + '-' + thisField.id];
                var modifiedValue = modified.templateValueStore[thisBlock.id + '-' + thisField.id];
                if (thisField.type == 'date' || thisField.type == 'datetime' || thisField.type == 'time') {
                  // date time field - compare using date compare
                  if (originalValue == "" && modifiedValue != "") {
                    // value was added - changes
                    blockChanges = true;
                    break;
                  } else if (originalValue != "" && modifiedValue == "") {
                    // value was removed - changes
                    blockChanges = true;
                    break;
                  } else if (originalValue == "" && modifiedValue == "") {
                    // no changes - do nothing
                  } else if (thisField.type == 'date') {
                    let original = originalValue;
                    if (original) {
                      original = originalValue.getTime();
                    }
                    let modified = modifiedValue;
                    if (modified) {
                      modified = modified.getTime();
                    }
                    if (original !== modified) {
                      blockChanges = true;
                      break;
                    }
                  } else if (thisField.type == 'time') {
                    let original = originalValue;
                    try {
                      if (original) {
                        original = original.toDate();
                        if (original) {
                          original = original.getTime()
                        }
                      }
                    } catch (err) {
                      original = originalValue;
                    }
                    let modified = modifiedValue;
                    try {
                      if (modified) {
                        modified = modified.toDate();
                        if (modified) {
                          modified = modified.getTime()
                        }
                      }
                    } catch (err) {
                      modified = modifiedValue;
                    }
                    if (original !== modified) {
                      blockChanges = true;
                      break;
                    }
                  }
                } else if (thisField.type == 'text' || thisField.type == 'boolean' ||
                  thisField.type == 'number' || thisField.type == 'select' || thisField.type == 'multiline') {
                  // text field - compare strings
                  if (originalValue !== modifiedValue) {
                    // a value has changed - do update
                    blockChanges = true;
                    break;
                  }
                }
              }

              if (blockChanges) {
                templateChanges = true;
                break;
              }
            }
          }

          if (templateChanges) {
            diffCount += 1;
            diffedDocket.templateValueStore = modified.templateValueStore;
            diffedDocket.template = modified.template;
          }
        }
      }

      if (modified.signatureFields) {
        var keys = Object.keys(modified.signatureFields);
        if (keys.length > 0) {
          diffCount += 1;
          diffedDocket.signatureFields = modified.signatureFields;
        }
      }

      var checklistChanges = false;
      if (original.checklists == null && modified.checklists != null) {
        // checklists have been added - do update
        checklistChanges = true;
      } else if (original.checklists != null && modified.checklists == null) {
        // checklists have been removed - do update
        checklistChanges = true;
      } else {
        var originalChecklistKeys = Object.keys(original.checklists);
        var modifiedChecklistKeys = Object.keys(modified.checklists);

        if (originalChecklistKeys.length != modifiedChecklistKeys.length) {
          // checklists have definitely changed - do update
          checklistChanges = true;
        } else {
          for (var i = 0; i < originalChecklistKeys.length; i++) {
            var currentKey = originalChecklistKeys[i];
            var originalChecklist = original.checklists[currentKey];
            var modifiedChecklist = modified.checklists[currentKey];

            // check if checklistTemplates are the same
            if (originalChecklist.checklistTemplateId != modifiedChecklist.checklistTemplateId) {
              checklistChanges = true;
              break;
            }
            // check if answers have changed
            var originalAnswerKeys = Object.keys(originalChecklist.answers);
            var modifiedAnswerKeys = Object.keys(modifiedChecklist.answers);

            if (originalAnswerKeys.length != modifiedAnswerKeys.length) {
              // answers have definitely changed - do updates
              checklistChanges = true;
              break;
            }

            for (var j = 0; j < originalAnswerKeys.length; j++) {
              var currentAnswerKey = originalAnswerKeys[j];
              if (originalChecklist.answers[currentAnswerKey] != modifiedChecklist.answers[currentAnswerKey]) {
                checklistChanges = true;
                break;
              }
            }

            if (checklistChanges) {
              break;
            }
          }
        }
      }

      if (checklistChanges) {
        diffCount += 1;
        diffedDocket.checklists = modified.checklists;
      }

      cb(diffedDocket, diffCount);
    }

    this.getDiffedDocket = getDiffedDocket;

    /**** Parse Dockets *****/
    var parseDockets = function (data) {
      var dockets = [];
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      if (data) {
        data.forEach(function (docket) {
          docket.status = docket.status.charAt(0).toUpperCase() + docket.status.slice(1);
          docket.loading = false;

          docket.assigned = false;
          if (organisation == null || organisationGroup == null) {
            var orgEmails = userService.getOrgEmailAddresses();
            for (var key in docket.accessControl) {
              if (orgEmails.indexOf(key) != -1) {
                docket.assigned = true;
                break;
              }
            }
          }

          dockets.push(docket);
        });
      }

      return dockets;
    }

    this.parseDockets = parseDockets;

    /****** Parse Dockets For Filing ******/
    var parseDocketsForFiling = function (data, fileStatus) {
      var dockets = [];
      if (data) {
        data.forEach(function (docket) {
          docket.loading = false;
          if (fileStatus == 'all') {
            dockets.push(docket);
          } else if (fileStatus == 'unfiled' && docket.existingDocketFile == null) {
            dockets.push(docket);
          } else if (fileStatus == 'filed' && docket.existingDocketFile != null) {
            dockets.push(docket);
          }
        });
      }

      return dockets;
    }

    this.parseDocketsForFiling = parseDocketsForFiling;


    /******************************/
    /****** Docket Templates ******/
    /******************************/

    /******* Get all docket templates for org group ********/
    this.getTemplates = function (query, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseTemplates = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('templates');

      if (query == null) {
        query = {};
      }

      baseTemplates.getList(query).then(successCb, failureCb);
    }

    /******** Get a single template *******/
    this.getTemplate = function (template, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseTemplates = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('templates');

      var templateId = template;
      if (template.id != null) {
        templateId = template.id;
      }

      baseTemplates.one(templateId).get().then(successCb, failureCb);
    }

    /******* Save Template *******/
    this.saveTemplate = function (template, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseTemplates = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('templates');

      var basicFields = ['active', 'id', 'name', 'populateResourcesFromJob', 'published', 'signature', 'checklistContainers', 'interactionTemplates', 'attachments', 'hiddenBlockNames', 'sumOnlyBillableInteractions', 'orderPrefillFields', 'pdfBuilder', 'minimumInteractionRequired'];
      var templateToSave = {};

      for (var i = 0; i < basicFields.length; i++) {
        if (template[basicFields[i]] != null) {
          templateToSave[basicFields[i]] = template[basicFields[i]];
        }
      }

      // blocks
      var blockFields = ['id', 'location', 'name', 'type'];
      if (template.blocks) {
        templateToSave.blocks = [];
        for (var i = 0; i < template.blocks.length; i++) {
          var newBlock = {};
          for (var j = 0; j < blockFields.length; j++) {
            if (template.blocks[i][blockFields[j]] != null) {
              newBlock[blockFields[j]] = template.blocks[i][blockFields[j]];
            }
          }
          if (template.blocks[i].fields) {
            newBlock.fields = [];
            for (var j = 0; j < template.blocks[i].fields.length; j++) {
              if (template.blocks[i].fields[j].id != null) {
                newBlock.fields.push(template.blocks[i].fields[j].id);
              }
            }
          }
          templateToSave.blocks.push(newBlock);
        }
      }

      // collapse checklist containers
      if (template.checklistContainers) {
        templateToSave.checklistContainers = [];
        for (var i = 0; i < template.checklistContainers.length; i++) {
          var checklistContainer = {};
          checklistContainer.location = i + 1;
          checklistContainer.rule = template.checklistContainers[i].rule;
          checklistContainer.id = template.checklistContainers[i].id;
          checklistContainer.checklistTemplate = template.checklistContainers[i].checklistTemplate.id;
          templateToSave.checklistContainers.push(checklistContainer);
        }
      }

      // collapse interaction template categories lists
      if (template.interactionTemplates) {
        for (var i = 0; i < template.interactionTemplates.length; i++) {
          if (template.interactionTemplates[i].actorCategories == null) {
            template.interactionTemplates[i].actorCategories = [];
          }
          for (var j = 0; j < template.interactionTemplates[i].actorCategories.length; j++) {
            if (template.interactionTemplates[i].actorCategories[j].id != null) {
              template.interactionTemplates[i].actorCategories[j] = template.interactionTemplates[i].actorCategories[j].id;
            }
          }
          for (var j = 0; j < template.interactionTemplates[i].categories.length; j++) {
            if (template.interactionTemplates[i].categories[j].id != null) {
              template.interactionTemplates[i].categories[j] = template.interactionTemplates[i].categories[j].id;
            }
          }
        }
        templateToSave.interactionTemplates = template.interactionTemplates;
      }

      // TODO: collapse attachments?
      if (template.id == null) {
        templateToSave.organisation = organisation.id;
        baseTemplates.post(templateToSave).then(successCb, failureCb);
      } else {
        baseTemplates.one(template.id).customPUT(templateToSave).then(successCb, failureCb);
      }
    }

    /****** Delete a template *******/
    var deleteTemplate = function (templateId, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseTemplates = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('templates');

      if (templateId.id != null) {
        templateId = templateId.id;
      }

      baseTemplates.one(templateId).remove().then(successCb, failureCb);
    }

    this.deleteTemplate = deleteTemplate;

    /******** Delete Bulk Templates ********/
    this.deleteBulkTemplates = function (templates, successCb) {
      var failures = [];
      deleteTemplates(templates, 0, failures, function (failuresFilled) {
        successCb(failuresFilled);
      });
    }

    var deleteTemplates = function (list, index, failures, successCb) {
      if (index >= list.length) {
        successCb(failures);
        return;
      }

      deleteTemplate(list[index].id, function (success) {
        deleteTemplates(list, index + 1, failures, successCb);
      }, function (err) {
        failures.push(list[index]);
        deleteTemplates(list, index + 1, failures, successCb);
      });
    }

    /******** Delete Docket Template Attachment *******/
    this.deleteTemplateAttachment = function (templateId, attachmentId, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseTemplates = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('templates');
      if (templateId.id != null) {
        templateId = templateId.id;
      }
      if (attachmentId.id != null) {
        attachmentId = attachmentId.id;
      }

      baseTemplates.one(templateId).all('attachment').one(attachmentId).remove().then(successCb, failureCb);
    }

    /******** Get all fields ***********/
    this.getFields = function (params, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseFields = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('fields');
      if (params == null) {
        params = {};
      }
      baseFields.getList(params).then(successCb, failureCb);
    }

    /********* Save a field *********/
    this.saveField = function (field, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseFields = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('fields');

      // patch for fixing bug where multiple of the same option are listed in a select field type
      if (field.type == 'select') {
        var selectionFieldsCleaned = [];
        for (var l = 0; l < field.selectionFields.length; l++) {
          if (selectionFieldsCleaned.indexOf(field.selectionFields[l]) == -1) {
            selectionFieldsCleaned.push(field.selectionFields[l]);
          }
        }
        field.selectionFields = selectionFieldsCleaned;
      }

      if (field.id == null) {
        field.organisation = organisation.id;
        baseFields.post(field).then(successCb, failureCb);
      } else {
        baseFields.one(field.id).customPUT(field).then(successCb, failureCb);
      }
    }

    /********* Delete a field *********/
    var deleteField = function (fieldId, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseFields = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('fields');

      if (fieldId.id != null) {
        fieldId = fieldId.id;
      }

      baseFields.one(fieldId).remove().then(successCb, failureCb);
    }

    this.deleteField = deleteField;

    /********** Delete Bulk Fields **********/
    this.deleteBulkFields = function (fields, successCb) {
      var failures = [];
      deleteFields(fields, 0, failures, function (failuresFilled) {
        successCb(failuresFilled);
      });
    }

    var deleteFields = function (list, index, failures, successCb) {
      if (index >= list.length) {
        successCb(failures);
        return;
      }

      deleteField(list[index].id, function (success) {
        deleteFields(list, index + 1, failures, successCb);
      }, function (err) {
        failures.push(list[index]);
        deleteFields(list, index + 1, failures, successCb);
      });
    }

    /********** Get all checklist templates ***********/
    this.getChecklistTemplates = function (params, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseChecklistTemplates = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('checklisttemplates');
      if (params == null) {
        params = {};
      }
      baseChecklistTemplates.getList(params).then(successCb, failureCb);
    }

    /********** Save Checklist Template **********/
    this.saveChecklistTemplate = function (checklistTemplate, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseChecklistTemplates = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('checklisttemplates');

      if (checklistTemplate.id == null) {
        baseChecklistTemplates.post(checklistTemplate).then(successCb, failureCb);
      } else {
        baseChecklistTemplates.one(checklistTemplate.id).customPUT(checklistTemplate).then(successCb, failureCb);
      }
    }

    /********* Delete Checklist Template **********/
    var deleteChecklistTemplate = function (templateId, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseChecklistTemplates = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('checklisttemplates');

      if (templateId.id != null) {
        templateId = templateId.id;
      }

      baseChecklistTemplates.one(templateId).remove().then(successCb, failureCb);
    }

    this.deleteChecklistTemplate = deleteChecklistTemplate;

    /********** Delete Bulk Checklist Templates **********/
    this.deleteBulkChecklistTemplates = function (templates, successCb) {
      var failures = [];
      deleteChecklistTemplates(templates, 0, failures, function (failuresFilled) {
        successCb(failuresFilled);
      });
    }

    var deleteChecklistTemplates = function (list, index, failures, successCb) {
      if (index >= list.length) {
        successCb(failures);
        return;
      }

      deleteChecklistTemplate(list[index].id, function (success) {
        deleteChecklistTemplates(list, index + 1, failures, successCb);
      }, function (err) {
        failures.push(list[index]);
        deleteChecklistTemplates(list, index + 1, failures, successCb);
      });
    }

  });



// WEBPACK FOOTER //
// ./src/services/docketService.js